/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import ApiClient from '../../ApiClient'
import AutoActionApi from '../../api/AutoActionApi'
import ApiHandle from '../../util/ApiHandle'
import { appActions } from '../AppActions'

export const AutoLogActionTypes = {
  processManualAction: 'auto_action/logs/process-manual-action',
  reprocessAutoAction: 'auto_action/logs/reprocess-auto-action'
}

const autoActionApi = new AutoActionApi(ApiClient.instance)

const AutoLogActions = {
  onRequestCreate: (id, content) => {
    const apiHandleOpts = {
      apiCall: () => autoActionApi.reprocessAutoAction({ auto_action_log_id: id, auto_action_mail_content: content }),
      onSucceded: response => {
        appActions.snackbar('再送しました', 'success', true)
      },
      onErrored: error => {
        appActions.showError(error.response.body, '再送に失敗しました')
      }
    }
    ApiHandle(apiHandleOpts)
  },

  onRequestUpdate: (id, content) => {
    const apiHandleOpts = {
      apiCall: () => autoActionApi.processManualAction(id, { auto_action_mail_content: content }),
      onSucceded: response => {
        appActions.snackbar('送信しました', 'success', true)
      },
      onErrored: error => {
        appActions.showError(error.response.body, '送信に失敗しました')
      }
    }
    ApiHandle(apiHandleOpts)
  }
}

export default AutoLogActions
